import $ from 'gridstrap/lib/gs-zepto';
import analytics from 'gridstrap/lib/gs-analytics';
declare var ga;

export class GSFormOption {

	//
	// Properties
	//

	private root;
	private group;
	private input;
	private other;
	private peers;

	get form() { return this.root.closest('.gs-Form'); }
	get name() { return this.input.prop('name'); }
	get checked() { return this.input.is(':checked');  }
	get disabled() { return this.root.hasClass('is-disabled'); }

	get value() { return this.input.val(); }
	set value(value) { this.input.val(value); }

	get isRadioBox() { return this.type == 'radiobox'; }
	get isSubmit() { return this.input.is('[role~="submit"]'); }
	get isOther() { return this.root.hasClass('gs-Form--isOther'); }

	get gaCategory() { return this.root.data('gsFormOptionGaCategory'); }
	get gaLabel()    { return this.root.data('gsFormOptionGaLabel'); }
	get gaActions()  { return (this.root.data('gsFormOptionGaActions') || '').split(' '); }

	get type() {
		let isRadiobox = this.root.hasClass('gs-FormOption--radiobox');
		return isRadiobox ? 'radiobox' : this.input.prop('type');
	}

	set checked(value) {
		if (this.checked != value) this.track(!!value ? 'check' : 'uncheck');
		this.input.prop('checked', !!value);
	}

	set disabled(value) {
		this.root.toggleClass('is-disabled', value);
		this.input.prop('disabled', value);
	}



	//
	// Methods
	//

	track(eventAction) {
		if (!this.gaActions.includes(eventAction)) return;
		let { gaCategory: eventCategory, gaLabel: eventLabel } = this;
		analytics.event({ eventCategory, eventAction, eventLabel });
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.input = this.root.find('.gs-FormOption-input');
		this.other = this.root.find('.gs-FormOption-otherInput');
		this.group = this.root.closest('.gs-Form, body');

		this.other.on({
			click: evt => evt.preventDefault(),
			blur: evt => this.handleOtherBlur(evt)
		});

		this.input.on({
			click: evt => this.handleClick(evt),
			change: () => this.handleChange()
		});

		this.peers = this.group
			.find(`[name="${this.name}"]`)
			.closest('.gs-FormOption')
			.not(this.root);
	}

	private handleClick(evt) {
		if (this.isRadioBox) this.handleRadioboxClick();
		if (this.isSubmit) this.form.submit();
		if (this.checked && this.isOther) this.other.focus();
	}

	private handleRadioboxClick() {
		this.peers.gs('checked', false);
	}

	private handleChange() {
		this.track(this.checked ? 'check' : 'uncheck');
		if (this.checked && this.other) this.other.focus(); //setTimeout(() => this.other.focus(), 500);
	}

	private handleOtherBlur(evt) {
		let value = $['trim'](this.other.val());
		this.value = value || 'Other';
	}
}
